/* eslint-disable no-undef */
/* eslint-disable no-console */

document.addEventListener("DOMContentLoaded", () => {
    // Check if JavaScript is enabled.
    if (typeof document !== 'undefined') {
        // JavaScript is enabled, remove 'js-disabled' class from the <body> element (added by WordPress hook).
        document.body.classList.remove('js-disabled');
        AOS.init();
	}
	// See child-functions.php and structure.scss for the 'js-disabled' class.

	new Mmenu("#mobile-menu", {
		slidingSubmenus: false,
		pageScroll: true,
		extensions: [
			"pagedim-black",
			"position-right",
			"position-front",
			"theme-dark",
		],
		counters: false,
		onClick: {
			close: true,
		},
		navbars: [
			{
				position: 'top',
				content: [
					'',
					'',
					'close'
				],
			},
		],
	});
});

(function ($) {
	"use strict";

	$(function () {

		// console.log(
		// 	"Width: " +
		// 	window.innerWidth +
		// 	", Height: " +
		// 	window.innerHeight
		// );




		$('#book-button').click(function () {
			console.log('asd');
			$('#booking-panel').toggleClass('active');
		});




		/**
		 * Bootstrap Modal - Booking Engine.
		 */
		if ($('#datepicker').length > 0) {

			$('#datepicker').pickadate({
				format: 'dd/mm/yyyy',
				formatSubmit: 'yyyy-mm-dd',
				hiddenSuffix: 'arrival',
			});

			$('#nights').select2(
				{
					placeholder: 'Nights',
					minimumResultsForSearch: -1
				}
			);

			$('#adults').select2(
				{
					placeholder: 'Adults',
					minimumResultsForSearch: -1
				}
			);

			$('#children').select2(
				{
					placeholder: 'Children',
					minimumResultsForSearch: -1
				}
			);

		}



		if ($('.wp-block-column.background-slideshow > .wp-block-group').length > 0) {

			$('.wp-block-column.background-slideshow > .wp-block-group').slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 4000,
			});
		}


		/**
		 * Desktop menu slide-in panel
		 * This code is for the slide-in panel that appears when the user clicks the menu icon.
		 * It ensures that the panel is not focusable when it is not visible.
		 * This is to prevent the panel from being read by screen readers when it is not visible.
		 * The panel is made focusable when it is visible.
		 * THe panel is made unfocusable when it is not visible.
		 */
		// Ensure no child elements inside .no-focus can receive focus
		$('.no-focus').attr('tabindex', '-1');

		// Ensure no child elements inside .no-focus can receive focus
		$('.no-focus').find('*').attr('tabindex', '-1');

		/**
		 * Desktop overlay navigation - Open
		 */
		$('#desktop-header .menu > button').on('click', function (event) {
			$('#myNav').css('width', '100%').addClass('open').removeAttr('tabindex').find('*').removeAttr('tabindex');
		});

		/**
		 * Desktop overlay navigation - Close
		 */
		$('#myNav button.closebtn').on('click', function (event) {
			$('#myNav').css('width', '0%').removeClass('open').attr('tabindex', '-1').find('*').attr('tabindex', '-1');
		});
		/**
		 * End.
		 */



		/**
		 * Header, sticky navbar.
		 */
		var $header = $('header#wrapper-navbar #desktop-header');
		$(window).on('scroll', function () {
			var scrollTop = $(this).scrollTop();
			if (scrollTop > 200) {
				// Scroll Down
				$header.addClass('scrolled');
			} else {
				// Scroll Up
				$header.removeClass('scrolled');
			}
		});



		if ($('.hero-large-photo').length > 0) {

			// The availability button, add aria attributes.
			$('.hero-large-photo').find('.wp-block-button.check-availability > a')
				.attr('role', 'button')
				.attr('aria-label', 'Check Availability')
				.attr('aria-pressed', 'false');

			/**
			 * Bootstrap Modal - Booking Engine.
			 * When the modal is shown, set the aria-pressed attribute to true.
			 * When the modal is hidden, set the aria-pressed attribute to false.
			 */
			// #bootstrap is the ID of the modal.
			$('#bootstrap').on('show.bs.modal', function() {
				$('.hero-large-photo').find('.wp-block-button.check-availability > a').attr('aria-pressed', 'true');
			});

			$('#bootstrap').on('hide.bs.modal', function() {
				$('.hero-large-photo').find('.wp-block-button.check-availability > a').attr('aria-pressed', 'false');
			});
		}



		/**
		 * Hero large photo slideshow.
		 * When a text link is clicked, the corresponding slide is shown.
		 * The text link is a hash link to the slide id.
		 * The slide id is the data-slide attribute of the slide.
		 * Built using ChatGTP:
		 * https://chatgpt.com/c/bb56f327-ca44-4bd1-913f-4de4d6b9fa27
		 */
		if ($('.hero-large-photo .background-slideshow').length > 0) {

			var $slickElement = $('.hero-large-photo .background-slideshow');

			// Show the slides after loading, prevents Content Layout Shift.
			$($slickElement).on("init", function (event, slick) {

				$($slickElement).css({
					visibility: "visible",
					height: "100%",
				});
			});

			$slickElement.slick({
				dots: false,
				infinite: true,
				speed: 400,
				slidesToShow: 1,
				arrows: false,
				fade: true,
				autoplay: true,
				autoplaySpeed: 4000,
				pauseOnHover: false,
			});

			// Find the first active slide
			var $activeSlide = $('.background-slideshow').find('.slick-active[data-slide]:not(.slick-cloned)');
			if ($activeSlide.length > 0) {
				// Get the data-slide attribute value
				var activeSlideId = $activeSlide.attr('data-slide');
				// Find the corresponding anchor tag in the .slideshow-buttons paragraph
				var $matchingAnchor = $('.slideshow-buttons').find('a[href="#' + activeSlideId + '"]');
				// Make the anchor tag bold
				$matchingAnchor.addClass('bold-anchor');
			}

			if ($('.slideshow-buttons').length > 0) {

				/**
				 * Click event listener for the anchor tags within the .slideshow-buttons paragraph.
				 */
				$('.slideshow-buttons a').each(function () {
					// Loop each anchor tag

					// Add click event listener to each anchor tag
					$(this).on('click', function (event) {

						event.preventDefault(); // Prevent default behavior of anchor tag
						// Get the href attribute value
						var slideId = $(this).attr('href');

						// Find the slide with the corresponding data-slide attribute
						var $slide = $('.background-slideshow').find('[data-slide="' + slideId.substring(1) + '"]:not(.slick-cloned)');

						// Check if the slide exists and is not a cloned slide
						if ($slide.length > 0 && !$slide.hasClass('slick-cloned')) {

							// Check if the clicked anchor corresponds to the current active slide
							if (!$slide.hasClass('slick-current') && !$slide.hasClass('slick-active')) {
								// Remove bold style from all anchor tags within .slideshow-buttons
								$('.slideshow-buttons a').removeClass('bold-anchor');

								// Change the slide
								var slideIndex = $slide.attr('data-slick-index');
								$('.background-slideshow').slick('slickGoTo', slideIndex);

								// Make the clicked anchor tag bold
								$(this).addClass('bold-anchor');
							}
						}

					});

				});


				/**
				 * After change event listener for the slideshow.
				 */
				$slickElement.on('afterChange', function(event, slick, currentSlide) {
					// Get the current slide element
					var $currentSlide = $(slick.$slides[currentSlide]);

					// Get the data-slide attribute value
					var dataSlideValue = $currentSlide.attr('data-slide');

					// Find the anchor with the matching href value
					var $matchingAnchor = $('.slideshow-buttons a[href="#' + dataSlideValue + '"]');

					$('.slideshow-buttons a').removeClass('bold-anchor');

					// Perform actions on the matching anchor
					if ($matchingAnchor.length > 0) {
						// Add your custom functionality here, e.g., add a class
						// $matchingAnchor.addClass('highlight');
						$matchingAnchor.addClass('bold-anchor');
					}
				});

			}

		}



		if ($('.marker_slideshow .slideshow').length > 0) {

			if ($('.marker_slideshow.single_map .slideshow').length > 0) {

				var $slickElement = $('.marker_slideshow.single_map .slideshow');

				$($slickElement).on("init", function (event, slick) {

					$($slickElement).css({
						visibility: "visible",
						height: "auto",
						overflow: "visible",
					});
				});

				$slickElement.slick({
					dots: false,
					infinite: false,
					speed: 500,
					slidesToShow: 4,
					arrows: true,
					autoplay: false,
					slidesToScroll: 1,
					responsive: [
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2,
							}
						}
					]

				});
			}

			if ($('.marker_slideshow.tab_map .slideshow').length > 0) {

				var $slickElement = $('.marker_slideshow.tab_map .slideshow');

				$($slickElement).on("init", function (event, slick) {

					$($slickElement).css({
						visibility: "visible",
						height: "auto",
						overflow: "visible",
					});

				});

				$slickElement.slick({
					dots: false,
					infinite: false,
					speed: 500,
					slidesToShow: 3,
					arrows: true,
					autoplay: false,
					slidesToScroll: 1,
					responsive: [
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2,
							}
						}
					]
				});
			}
		}



		if ($('.testimonials .slideshow').length > 0) {

			var $slickElement = $('.testimonials .slideshow');

			$($slickElement).on("init", function (event, slick) {

				$($slickElement).css({
					visibility: "visible",
					height: "auto",
					overflow: "visible",
				});
			});

			$slickElement.slick({
				dots: true,
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				arrows: false,
				autoplay: true,
			});

		}



		if ($('div.latest-posts-slideshow').length > 0) {

			var $slickElement = $('div.latest-posts-slideshow');

			$($slickElement).on("init", function (event, slick) {

				if (slick.slideCount === 1) {
					slick.$slider.parent().find('.counter-info').hide();
				}

				$($slickElement).css({
					visibility: "visible",
					height: "auto",
					overflow: "visible",
				});
			});

			$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {

				if (slick.slideCount > 1) {

					var $status = slick.$slider.parent().find('.counter-info');

					//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
					var i = (currentSlide ? currentSlide : 0) + 1;

					$status.html('<span class="current_slide">' + i + '</span> / <span class="total_slides"> ' + slick.slideCount + '</span>');
				}

			});

			$slickElement.slick({
				dots: false,
				infinite: true,
				speed: 500,
				slidesToShow: 2,
				arrows: true,
				autoplay: false,
				responsive: [
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});

		}



		if ($('.wp-block-column.alternating-slideshow .slideshow').length > 0) {

			var $slickElement = $('.wp-block-column.alternating-slideshow .slideshow');

			$($slickElement).on("init", function (event, slick) {

				if (slick.slideCount === 1) {
					slick.$slider.parent().find('.counter-info').hide();
					slick.$slider.parent().find('figcaption').addClass('single-slide');
				}

				$($slickElement).css({
					visibility: "visible",
					height: "auto",
				});
			});

			$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {

				if (slick.slideCount > 1) {

					var $status = slick.$slider.parent().find('.counter-info');

					//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
					var i = (currentSlide ? currentSlide : 0) + 1;

					$status.html('<span class="current_slide">' + i + '</span> / <span class="total_slides"> ' + slick.slideCount + '</span>');
				}

			});

			$slickElement.slick({
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				arrows: true,
				fade: false,
				autoplay: true,
			});

			$('.slick-slider').on('click', '.slick-slide', function (e) {
				e.stopPropagation();
				var index = $(this).data("slick-index");
				if ($('.slick-slider').slick('slickCurrentSlide') !== index) {
				$('.slick-slider').slick('slickGoTo', index);
				}
			});

		}



		if ($('.room-accordion .slideshow').length > 0) {

			var $slickElement = $('.room-accordion .slideshow');

			$($slickElement).on("init", function (event, slick) {

				if (slick.slideCount === 1) {
					slick.$slider.parent().find('.counter-info').hide();
					slick.$slider.parent().find('figcaption').addClass('single-slide');
				}

				if (slick.slideCount > 1) {
					slick.$slider.parent().parent().addClass('multi-slide');
				}

				$($slickElement).css({
					visibility: "visible",
					height: "auto",
					overflow: "visible",
				});
			});

			$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {

				if (slick.slideCount > 1) {

					var $status = slick.$slider.parent().find('.counter-info');

					//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
					var i = (currentSlide ? currentSlide : 0) + 1;

					$status.html('<span class="current_slide">' + i + '</span> / <span class="total_slides"> ' + slick.slideCount + '</span>');
				}

			});

			$slickElement.slick({
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				arrows: true,
				fade: true,
				autoplay: true,
			});

			$('.slick-slider').on('click', '.slick-slide', function (e) {
				e.stopPropagation();
				var index = $(this).data("slick-index");
				if ($('.slick-slider').slick('slickCurrentSlide') !== index) {
				$('.slick-slider').slick('slickGoTo', index);
				}
			});

		}




		/**
		 * For each .wp-block-column.alternating-slideshow, find the widest button and set all buttons in that section to that width.
		 */
		if ($('.same-width').length > 0) {

			$('.same-width').each(function() {
				var $buttons = $(this).find('.wp-element-button');
				var maxWidth = 0;

				// Calculate the maximum width among the buttons
				$buttons.each(function() {
					var buttonWidth = $(this).outerWidth();
					if (buttonWidth > maxWidth) {
						maxWidth = buttonWidth;
					}
				});

				// Set each button to the maximum width
				$buttons.css('width', maxWidth + 'px');
			});

		}



		// Google Map - Multiple Pins
		if ($('#mp_map_canvas').length > 0) {
			// Initialise Google Map with multiple pins
			var mapElement = $('#mp_map_canvas');
			window.addEventListener('load', function() {
				mp_initialize(mapElement);
			});
		}



		// Google Map - Multiple Pins
		// ------------------------------ //

		var mp_map, mp_lat, mp_lng, mp_zoom, mp_centre,
			latlngbounds, mp_latlng, mp_center, mp_position, mp_marker, attractions_marker = [];

		// Google map is initialised on clicking a#tab2 below

		function mp_initialize(mapElement) {

			var LatLngList = [];

			mp_lat       = 50.329070;
			mp_lng       = -4.794120;
			mp_zoom      = 7;
			mp_centre    = new google.maps.LatLng(mp_lat, mp_lng);
			latlngbounds = new google.maps.LatLngBounds();

			var locations = getLocations(mapElement);

			// var mp_touch = false;
			// if( $('html.no-touch').length > 0 ) { mp_touch = true; }
			// checks to see if mobile or desktop (screen touch available), then enable / disable map drag

			var mp_touch = true;

			var mp_mapOptions = {
				zoom: mp_zoom,
				minZoom: 1,
				maxZoom: 18,
				center: mp_centre,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				draggable: mp_touch,
				mapId: "64d66a5748ab34fa", // Map ID is required for advanced markers.
			};

			mp_map = new google.maps.Map(document.getElementById('mp_map_canvas'), mp_mapOptions);


			/**
			 * Add single hotel marker to map.
			 */
			addHotelMarker( mp_lat, mp_lng, mp_map );


			/**
			 * Add all attraction markers to map.
			 */
			addAttractionMarkers( locations, mp_map, false );




			/**
			 * Bound the map to display all pins.
			 */
			// Add hotel center map to LatLngList.
			LatLngList.push(new google.maps.LatLng(mp_lat, mp_lng));

			// Loop points of interest and add lat lng to LatLngList.
			$.each(
				locations,
				function () {
					// addMarker(this);

					// new google.maps.LatLng (this.lat,this.lng);
					LatLngList.push( new google.maps.LatLng( this.lat, this.lng ) );

				}
			);

			// http://stackoverflow.com/questions/2818984/google-map-api-v3-center-zoom-on-displayed-markers
			// http://stackoverflow.com/questions/15719951/google-maps-api-v3-auto-center-map-with-multiple-markers
			LatLngList.forEach(function (LatLngList) {
				latlngbounds.extend(LatLngList);
			});
			mp_map.fitBounds(latlngbounds);
			/**
			 * End.
			 */



			// //loop points of interest and add markers and infowindows
			// $.each(places, function () {
			// 	addMarker(this);
			// });



			// Keeps the pin in the centre of the map on window resize
			// google.maps.event.addDomListener(mp_map, 'idle', function() {
			// 	mp_center = mp_map.getCenter();
			// });
			// google.maps.event.addDomListener(window, 'resize', function() {
			// 	mp_map.setCenter(mp_center);
			// });

		}

		// ------------------------------ //
		// Google Map - Multiple Pins


		// function hideOverlay() {
		// 	$('.map-hotel').css({
		// 		display: "none"
		// 	});
		// }



		// Tabs - Google Map - Multiple Pins
		if ($('.mp_map_canvas').length > 0) {
			// Initialise Google Map with multiple pins for each map canvas element
			$('.mp_map_canvas').each(function() {
				var mapElement = this;
				window.addEventListener('load', function() {
					mp_tabs_initialize(mapElement);
				});
			});
		}



		// Tabs - Google Map - Multiple Pins
		// ------------------------------ //

		var mp_lat, mp_lng, mp_zoom, latlngbounds;

		function mp_tabs_initialize(mapElement) {
			var LatLngList = [];

			mp_lat = 50.329070;
			mp_lng = -4.794120;
			mp_zoom = 7;
			latlngbounds = new google.maps.LatLngBounds();

			var locations = getLocations(mapElement);

			var mp_touch = true;

			var mp_mapOptions = {
				zoom: mp_zoom,
				minZoom: 1,
				maxZoom: 18,
				center: new google.maps.LatLng(mp_lat, mp_lng),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				draggable: mp_touch,
				mapId: "64d66a5748ab34fa", // Map ID is required for advanced markers.
			};

			var mp_map = new google.maps.Map(mapElement, mp_mapOptions);

			addHotelMarker(mp_lat, mp_lng, mp_map);

			addAttractionMarkers(locations, mp_map, true);

			LatLngList.push(new google.maps.LatLng(mp_lat, mp_lng));

			$.each(locations, function() {
				LatLngList.push(new google.maps.LatLng(this.lat, this.lng));
			});

			LatLngList.forEach(function(LatLng) {
				latlngbounds.extend(LatLng);
			});
			mp_map.fitBounds(latlngbounds);
		}

		// ------------------------------ //
		// Tabs - Google Map - Multiple Pins



		function getLocations(mapElement) {

			var locations = [];

			var markerContainer       = $(mapElement).closest('.marker_container');
			var this_marker_locations = markerContainer.siblings('.marker_locations');

			$.each(
				$(this_marker_locations).find('.marker'),
				function () {
					// addMarker(this);

					// new google.maps.LatLng (this.lat,this.lng);
					locations.push(
						{
							"name": $(this).data('name'),
							"icon": $(this).data('icon'),
							"lat": $(this).data('lat'),
							"lng": $(this).data('lng')
						}
					);

				}
			);

			return locations;
		}


		function addHotelMarker( mp_lat, mp_lng, mp_map ) {

			mp_position = new google.maps.LatLng( mp_lat, mp_lng );

			const hotelMarkerImg = document.createElement("img");

			hotelMarkerImg.src =
			"/wp-content/themes/thecornwall/img/google-map-the-cornwall-3.png";

			// The advanced marker.
			mp_marker = new google.maps.marker.AdvancedMarkerElement({
				map: mp_map,
				position: mp_position,
				content: hotelMarkerImg,
				title: 'marker_thecornwall',
			});

			return mp_marker;

		}


		function addAttractionMarkers(locations, mp_map, tabs) {

			$.each(
				locations,
				function () {

					const attractionMarkerImg = document.createElement("img");
					attractionMarkerImg.src = this.icon;
					attractionMarkerImg.alt = this.name; // Adding alt attribute

					let lowerCaseStr = this.name.toLowerCase();

					// Replace spaces with hyphens
					let hyphenatedStr = lowerCaseStr.replace(/\s+/g, '-');

					// The advanced marker.
					mp_marker = new google.maps.marker.AdvancedMarkerElement({
						map: mp_map,
						position: { lat: parseFloat( this.lat ), lng: parseFloat( this.lng ) },
						content: attractionMarkerImg,
						title: hyphenatedStr,
					});

					if (tabs) {
						// Only execute this code if we are on the Tab Map Attractions (multiple Google Maps) block.

						mp_marker.addListener('click', function(e) {
							var targetElement = $(e.domEvent.target); // Access the target element of the DOM event
							// var titleValue = targetElement.parent().parent().prop('title'); // Store the title property value in a variable
							// $('#marker_slideshow').find('#' + titleValue).addClass('selected');

							targetElement.closest('.mp_map_canvas_sibling').find('.animate').removeClass('animate');
							targetElement.addClass('animate');

							// Get the JSON strong.
							var markersData = targetElement.closest('.marker_container').siblings('.markers-data').html();

							// Parse the content as JSON.
							var markers = JSON.parse(markersData);
							// Now you can work with the markers array.

							// Find the relevant data from the markers array
							var relevantData = markers.find(function(marker) {
								return marker.id === hyphenatedStr;
							});

							if (typeof relevantData === 'object' && relevantData !== null && Object.keys(relevantData).length > 0) {

								var $this_mp_map_canvas_overlay = $('.mp_map_canvas_overlay');

								// Update the content of the existing mp_map_canvas_overlay and its child elements
								$this_mp_map_canvas_overlay.find('.title').text(relevantData.overlay.title);

								// Change background photo
								$this_mp_map_canvas_overlay.find('.background_photo img')
									.prop('src', relevantData.overlay.background_photo.sizes.large)
									.prop('alt', relevantData.overlay.background_photo.alt);

								// Construct the srcset attribute
								var srcset = '';
								for (var key in relevantData.overlay.background_photo.sizes) {
									if (relevantData.overlay.background_photo.sizes.hasOwnProperty(key) && key.includes('-width')) {
										var sizeKey = key.replace('-width', '');
										var width = relevantData.overlay.background_photo.sizes[key];
										srcset += relevantData.overlay.background_photo.sizes[sizeKey] + ' ' + width + 'w, ';
									}
								}

								// Remove the trailing comma and space
								srcset = srcset.slice(0, -2);

								$this_mp_map_canvas_overlay.find('.background_photo img').prop('srcset', srcset);

								// Optionally update other attributes
								$this_mp_map_canvas_overlay.find('.background_photo img').prop('src', relevantData.overlay.background_photo.sizes['large']);
								$this_mp_map_canvas_overlay.find('.background_photo img').prop('width', relevantData.overlay.background_photo.sizes['large-width']);
								$this_mp_map_canvas_overlay.find('.background_photo img').prop('height', relevantData.overlay.background_photo.sizes['large-height']);

								// Change top text
								if (relevantData.overlay.top_text.length > 0) {
									$this_mp_map_canvas_overlay.find('.top_text').show().text(relevantData.overlay.top_text);
								} else {
									$this_mp_map_canvas_overlay.find('.top_text').hide();
								}

								// Change summary
								if (relevantData.overlay.summary.length > 0) {
									$this_mp_map_canvas_overlay.find('.summary').show().text(relevantData.overlay.summary);
								} else {
									$this_mp_map_canvas_overlay.find('.summary').hide();
								}

								// Change button
								if (!$.isEmptyObject(relevantData.overlay.button) &&
									(relevantData.overlay.button.url.length > 0 && relevantData.overlay.button.title.length > 0)) {
									$this_mp_map_canvas_overlay.find('.button').show();
									$this_mp_map_canvas_overlay.find('.button a')
										.text(relevantData.overlay.button.title)
										.prop('href', relevantData.overlay.button.url)
										.prop('target', relevantData.overlay.button.target);
								} else {
									$this_mp_map_canvas_overlay.find('.button').hide();
								}
							} else {
								// console.log('No relevant data found or relevantData is not an object.');
							}

						});
					}
				}
			);

			return attractions_marker;

		}

		/**
		 * Marker Slideshow
		 * When a link is clicked, the corresponding marker is animated.
		 */
		$('.marker_slideshow a').on('click', function(event) {
			event.preventDefault(); // Prevent the default action of the link

			var linkId = $(this).attr('id'); // Get the id attribute of the clicked link

			if ($(this).hasClass('selected')) {

				// If the clicked link already has the 'selected' class, remove it.
				$(this).removeClass('selected');

				$(this).closest('.marker_slideshow').siblings('.mp_map_canvas_sibling').find('.animate').removeClass('animate');

			} else {

				/**
				 * Update the map pin animation.
				 */

				var anchorId = $(this).attr('id');

				// Remove 'selected' class from any previously selected link.
				$('.marker_slideshow a.selected').removeClass('selected');

				// Add 'selected' class to the clicked link
				$(this).addClass('selected');

				var $closest_marker_slideshow = $(this).closest('.marker_slideshow');

				var $closest_marker_slideshow_sibling = $closest_marker_slideshow.siblings('.mp_map_canvas_sibling');

				// Remove 'animate' class from any element inside #mp_map_canvas
				$closest_marker_slideshow_sibling.find('.animate').removeClass('animate');

				// Find the element with the matching title attribute
				var markerElement = $closest_marker_slideshow_sibling.find('div [title="' + linkId + '"]');
				// var markerElement = $closest_marker_slideshow.siblings('#mp_map_canvas [title="' + linkId + '"]');

				if (markerElement.length) {
					markerElement.addClass('animate'); // Add the 'animate' class to the marker element
					// console.log('Marker element found and animated:', markerElement); // Log the marker element to the console
				} else {
					// console.log('No marker element found with title:', linkId); // Log if no element is found
				}

				/**
				 * Now change the overlay element data.
				 */

				// Get the JSON strong.
				var markersData = $(this).closest('.marker_container').siblings('.markers-data').html();

				// Parse the content as JSON.
				var markers = JSON.parse(markersData);
				// Now you can work with the markers array.

				// Find the relevant data from the markers array
				var relevantData = markers.find(function(marker) {
					return marker.id === anchorId;
				});

				// Check if relevantData is an object and has properties
				if (typeof relevantData === 'object' && relevantData !== null && Object.keys(relevantData).length > 0) {

					var $this_mp_map_canvas_overlay = $(this).closest('.marker_slideshow.tab_map').siblings('.mp_map_canvas_overlay')

					// Update the content of the existing mp_map_canvas_overlay and its child elements.
					$this_mp_map_canvas_overlay.find('.title').text(relevantData.overlay.title);

					//
					// Change background photo.
					$this_mp_map_canvas_overlay.find('.background_photo img').prop('src', relevantData.overlay.background_photo.sizes.large).prop('alt', relevantData.overlay.background_photo.alt);

					// Construct the srcset attribute
					var srcset = '';
					for (var key in relevantData.overlay.background_photo.sizes) {
						if (relevantData.overlay.background_photo.sizes.hasOwnProperty(key) && key.includes('-width')) {
							var sizeKey = key.replace('-width', '');
							var width = relevantData.overlay.background_photo.sizes[key];
							srcset += relevantData.overlay.background_photo.sizes[sizeKey] + ' ' + width + 'w, ';
						}
					}

					// Remove the trailing comma and space
					srcset = srcset.slice(0, -2);

					$this_mp_map_canvas_overlay.find('.background_photo img').prop('srcset', srcset);

					// Optionally update other attributes
					$this_mp_map_canvas_overlay.find('.background_photo img').prop('src', relevantData.overlay.background_photo.sizes['large']);
					$this_mp_map_canvas_overlay.find('.background_photo img').prop('width', relevantData.overlay.background_photo.sizes['large-width']);
					$this_mp_map_canvas_overlay.find('.background_photo img').prop('height', relevantData.overlay.background_photo.sizes['large-height']);
					// Change background photo.
					//

					// Change top text.
					if ( relevantData.overlay.top_text.length > 0 ) {
						$this_mp_map_canvas_overlay.find('.top_text').show().text(relevantData.overlay.top_text);
					} else {
						$this_mp_map_canvas_overlay.find('.top_text').hide()
					}

					// Change summary.
					if ( relevantData.overlay.summary.length > 0 ) {
						$this_mp_map_canvas_overlay.find('.summary').show().text(relevantData.overlay.summary);
					} else {
						$this_mp_map_canvas_overlay.find('.summary').hide()
					}

					// Change button.
					if (
						!$.isEmptyObject(relevantData.overlay.button) &&
						(relevantData.overlay.button.url.length > 0 && relevantData.overlay.button.title.length > 0)
					) {
						$this_mp_map_canvas_overlay.find('.button').show();
						$this_mp_map_canvas_overlay.find('.button a').text(relevantData.overlay.button.title).prop('href', relevantData.overlay.button.url).prop('target', relevantData.overlay.button.target);
					} else {
						$this_mp_map_canvas_overlay.find('.button').hide()
					}

				} else {
					// No relevant data found or relevantData is not an object.
				}
			}
		});

		// ------------------------------ //
		// Google Map - Multiple Pins




		/**
		 * If we close the Vimeo player in the Bootstrap modal,
		 * then stop the player.
		 */
        $('#vimeo_1').on('hidden.bs.modal', function () {
            var iframe = document.querySelector('#vimeo_1_player');
            if (iframe) {
                var player = new Vimeo.Player(iframe);
                player.pause().catch(function (error) {
                    console.error('Error stopping the video:', error);
                });
            }
        });

		/**
		 * Add an event listener to the close button to stop the Vimeo player.
		 */
		$('.btn-close').on('click', function () {
			var iframe = document.querySelector('#vimeo_1_player');
			if (iframe) {
				var player = new Vimeo.Player(iframe);
				player.pause().catch(function (error) {
					console.error('Error stopping the video:', error);
				});
			}
		});



	});

	$(window).on('load', function () {

		var hash = window.location.hash;

		let intViewportWidth = window.innerWidth; // Use Web API.
		// let intViewportHeight = window.innerHeight; // Use Web API.

		// console.log('window loaded');

		/**
		 * Smooth scroll - 2 - Start.
		 */
		// Prevents the automatic jump.
		if (location.hash) { // do the test straight away
			window.scrollTo(0, 0); // execute it straight away
			setTimeout(function() {
				window.scrollTo(0, 0); // run it a bit later also for browser compatibility
			}, 1);
		}
		// Prevents the automatic jump.

		var top_space = 0;
		if ( intViewportWidth <= 767 ) {
			top_space = 70 + 20;
		} else {
			top_space = 61 + 20;
		}

		/**
		 * If coming from another page.
		 */
		if ( hash ) {
			var hash = window.location.href.split("#")[1];
			if (hash && $('#' + hash).length)
			$('html,body').animate({
				scrollTop: $('#' + hash).offset().top - top_space
			}, 800, 'swing');
		}

		/**
		 * If already on the page and you click a has link.
		 */
		$("a[href*='#']:not([href='#'])").click(function (e) {

			var hash = this.hash;

			if ($(this).closest('.marker_slideshow').length) {
				// If the anchor is within the .marker_slideshow element...
				return false;
			}

			if (
				'#mobile-menu' !== hash &&
				'#open-nav' !== hash &&
				'#close-nav' !== hash &&
				!$(e.currentTarget).hasClass('bold-anchor')
			) {
				// only slide down if not on mobile and mobile menu button clicked or not bold anchor clicked.

				var origin   = this.origin;
				var pathname = this.pathname;

				var current_window_location = window.location.href;
				var click_window_location = origin + pathname;

				if ( current_window_location === click_window_location) {
					// We are already on the same page as the clicked button url.

					e.preventDefault();

					if ( hash ) {
						// If already on the page.

						$('html,body').animate({
							scrollTop: $(hash).offset().top - top_space
						}, 1000, 'swing');
					}
				}
			}
		});
		/**
		 * Smooth scroll - 2 - Finish.
		 */


		/**
		 * Desktop menu, hover over menu item to change the image in the overlay.
		 * https://chatgpt.com/c/2dddc6dd-d710-4dd5-badb-c44d0b7a4d60
		 */
		// Store the original image source
		var originalSrc = $('#current-photo').attr('src');
		var originalSrcset = $('#current-photo').attr('srcset');

        // Hover event on the menu item.
		$('ul#main-menu li.menu-item').mouseenter(function (event) {
			event.stopPropagation(); // Prevent the event from bubbling up

			var $this = $(this);

			// Check if the immediate 'a' element has a span with data-menu-photo
			var $span = $this.children('a').children('span[data-menu-photo]');

			// Get the image elements
			var $currentImg = $('#current-photo');
			var $newImg = $('#new-photo');

			// Stop any ongoing animations
			$newImg.stop(true, true);
			$currentImg.stop(true, true);

			if ($span.length) {

				// Get the data-menu-photo attribute value
				var newSrc = $span.attr('data-menu-photo');

				// Change the src and srcset attributes of the image
				// var $newImg = $('#new-photo');
				$newImg.attr('src', newSrc);
				$newImg.attr('srcset', newSrc);
				$newImg.fadeIn('slow', function() {
					// var $currentImg = $('#current-photo');
					$currentImg.attr('src', newSrc);
					$currentImg.attr('srcset', newSrc);
					$newImg.hide();
				});
			} else {
				// Revert to the original image with a slow fade if no data-menu-photo is found and the images are different
				if ($currentImg.attr('src') !== originalSrc) {
					$newImg.attr('src', originalSrc);
					$newImg.attr('srcset', originalSrcset);
					$newImg.fadeIn('slow', function() {
						$currentImg.attr('src', originalSrc);
						$currentImg.attr('srcset', originalSrcset);
						$newImg.hide();
					});
				}
			}
		});




		/**
		 * Desktop menu, click parent menu item to show the submenu.
		 * https://chatgpt.com/g/g-HxPrv1p8v-code-tutor/c/ae391650-d8bd-4b5d-9a83-bce765b94ae1
		 * Needs to integrate with existing Bootstrap menu and code.
		 */
		// Function to handle closing of dropdowns
		function closeDropdowns($except) {
			$('.dropdown-menu').not($except).each(function() {
				var $menu = $(this);
				if ($menu.is(':visible')) {
					$menu.addClass('closing').removeClass('opening');
					$menu.closest('.dropdown').removeClass('show');
					setTimeout(function() {
						$menu.removeClass('closing').css('display', 'none');
					}, 1000); // Match this duration with your CSS transition
				}
			});
		}

		// Attach a show event to the dropdown menu
		$('.dropdown').on('show.bs.dropdown', function(e) {
			var $this = $(this);
			var $dropdownMenu = $this.find('.dropdown-menu');

			// Close all open dropdowns except the one being opened
			closeDropdowns($dropdownMenu);

			// Add classes to handle the opening transition
			$dropdownMenu.css('display', 'block');
			setTimeout(function() {
				$dropdownMenu.addClass('opening');
			}, 10); // Small delay to trigger the transition
		});

		// Attach a hide event to the dropdown menu
		$('.dropdown').on('hide.bs.dropdown', function(e) {
			var $dropdownMenu = $(this).find('.dropdown-menu');

			// Add classes to handle the closing transition
			$dropdownMenu.addClass('closing').removeClass('opening');
			setTimeout(function() {
				$dropdownMenu.removeClass('closing').css('display', 'none');
			}, 400); // Match this duration with your CSS transition
		});

		// Prevent closing the dropdown when clicking inside
		$('.dropdown-menu').on('click', function(e) {
			e.stopPropagation();
		});

	});

})(jQuery);
